import * as React from "react";
import { Col, Form, Row } from "react-bootstrap";
import Address from "../form/Address";
import City from "../form/City";
import State from "../form/State";
import Zip from "../form/Zip";
import FirstName from "../form/FirstName";
import LastName from "../form/LastName";
import { config } from '_config';

export default function OfficeActionStep2({ state, onChange, validated }) {

  const handleChange = (e) => {
    onChange(e);
  };

  return (
    <Form id="TrademarkForm" noValidate validated={validated}>
      <div className="question">
        {config.skin === 'v2-basic' && <h2>Changes</h2>}
        <div className="polaroid">
        <p className="primary-label">Do you need to change your address?</p>
        <div className="mb-3">
          <Form.Check
            inline
            label="Yes"
            name="changeAddress"
            type="radio"
            id="changeAddress1"
            value={"true"}
            checked={state.changeAddress === "true"}
            onChange={handleChange}
          />
          <Form.Check
            inline
            label="No"
            name="changeAddress"
            id="changeAddress2"
            type="radio"
            value={"false"}
            checked={state.changeAddress === "false"}
            onChange={handleChange}
          />
        </div>
        <div className="two-column-form">
          {state.changeAddress === "true" ?           <Form.Group as={Row}>
            <Col sm={6}>
              <Address id="newaddress" label="Address" state={state} onChange={handleChange} />
            </Col>
            <Col sm={6}>
              <City id="newcity" label="City" state={state} onChange={handleChange} />
            </Col>
            <Col sm={6}>
              <State id="newstate" label="State/Province/Region" state={state} onChange={handleChange} />
            </Col>
            <Col sm={6}>
              <Zip id="newzip" label="Zip/Postal Code" state={state} onChange={handleChange} />
            </Col>
          </Form.Group> : <></>}
        </div>
        </div>
        <div className="polaroid">
        <p className="primary-label">Do you need to submit a new drawing of the mark?</p>
        <div className="mb-3">
          <Form.Check
            inline
            label="Yes"
            name="newDrawing"
            type="radio"
            id="newDrawing1"
            value={"true"}
            checked={state.newDrawing === "true"}
            onChange={handleChange}
          />
          <Form.Check
            inline
            label="No"
            name="newDrawing"
            id="newDrawing2"
            type="radio"
            value={"false"}
            checked={state.newDrawing === "false"}
            onChange={handleChange}
          />
        </div>
        {state.newDrawing==="true" ? <p style={{color:"red"}}>Please note, you will be asked to upload your logo after you create your account.</p> : <></>}
        </div>
        <div className="polaroid">
        <p className="primary-label">Do you need to make a change to name of the mark owner?</p>
        <div className="mb-3">
          <Form.Check
            inline
            label="Yes"
            name="changeMarkOwner"
            type="radio"
            id="changeMarkOwner1"
            value={"true"}
            checked={state.changeMarkOwner === "true"}
            onChange={handleChange}
          />
          <Form.Check
            inline
            label="No"
            name="changeMarkOwner"
            id="changeMarkOwner2"
            type="radio"
            value={"false"}
            checked={state.changeMarkOwner === "false"}
            onChange={handleChange}
          />
        </div>
        {state.changeMarkOwner==="true" ? <div className="two-column-form">
          <FirstName id="changeMarkOwnerFirstName" label="Enter corrected First Name" value={state.changeMarkOwnerFirstName} onChange={handleChange} />
          <LastName id="changeMarkOwnerLastName" label="Enter corrected Last Name" value={state.changeMarkOwnerLastName} onChange={handleChange} />
          <Form.Group as={Row} className="mb-3" controlId="changeMarkOwnerDesc">
            <Form.Label column required>Provide an explanation for the change</Form.Label>
            <Form.Control
              type="text"
              required
              placeholder="Provide an explanation for the change"
              onChange={handleChange}
              data-hj-allow
              value={state.changeMarkOwnerDesc ? state.changeMarkOwnerDesc : ""}
            />
            <Form.Control.Feedback type="invalid">Please provide a description</Form.Control.Feedback>
          </Form.Group>
        </div>: <></>}
      </div>
      </div>
    </Form>
  );
}
